import { signUp } from '../../../lib/analytics/events'

// Store previous error messages for each field
const prevFieldErrors = {}

/**
 * Tracks Google Analytics events for form validation errors.
 * - Fires validationError only when the error message is visible to the user.
 *
 * @param {Object} field - The form field object from React Hook Form
 * @param {string} field.name - The field identifier (e.g. 'email', 'password')
 * @param {Object} error - The validation error object for this field
 * @param {string} error.message - The error message if validation failed
 * @param {number} datalayerStepSequence - The sequential step number in the signup flow for Datalayer analytics
 * @param {string} datalayerStepLabel - The step label in the signup flow for Datalayer analytics
 * @param {boolean} isErrorVisible - Indicates whether the error message is currently shown in the UI
 *   (e.g. some fields like birthYear can show validation errors before form submission,
 *   while others only show errors after submission)
 *
 * @example
 * handleGATrack(
 *   { name: 'email' },
 *   errors.email,
 *   1,
 *   'create account',
 *   true
 * )
 */
export const handleGATrack = (
  field,
  error,
  datalayerStepSequence,
  datalayerStepLabel,
  isErrorVisible
) => {
  const fieldName = field.name
  const errorMessage = error?.message

  // Get the previous error message for this field
  const prevErrorMessage = prevFieldErrors[fieldName]

  // Track validation error only when the error is visible to the user
  // 1) Only track if the error is visible
  // 2) the new error msg is different to the last one(by field)
  if (isErrorVisible && errorMessage && errorMessage !== prevErrorMessage) {
    signUp.validationError(
      `${fieldName}: ${errorMessage}`,
      datalayerStepSequence,
      datalayerStepLabel
    )
    // Store the current error state for future comparisons
    prevFieldErrors[fieldName] = errorMessage
  }
}
